module.exports = __webpack_public_path__ + "static/media/Maple.79d820f3.jpg";